<template>
    <SwiperSlider 
        type="featured" 
        v-if="campaigns.length"
        :campaigns="campaigns" 
        title="Featured Campaigns"/>
</template>

<script>
    import SwiperSlider from '../SwiperSlider/index.vue'
    import useFeatured from './useFeatured'
    export default {
        name: "FeaturedCampaigns",
        setup() {
            const {
                campaigns
            } = useFeatured();
            return {
                campaigns,
            };
        },
        components: {
            SwiperSlider
        },
    };
</script>